import styled from "@xstyled/styled-components";

export const InfoTextSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: sm;
`;
